import React from "react";
import Banner from "../components/Banner";
import Title from "../components/Title";
import EditorNote from "../components/EditorNote";


const IntroPage = () => {
  return (
    <div>
        <Banner></Banner>
        <Title></Title>
        <EditorNote></EditorNote>
    </div>
    
  );
};

export default IntroPage;